module.exports = __webpack_public_path__ + "img/giraffe.2b966d3.png";